import { AnimatePresence, type AnimatePresenceProps } from 'framer-motion';
import type React from 'react';

interface NewAnimatePresenceProps extends Omit<AnimatePresenceProps, 'children'> {
  children: React.ReactNode;
}

export function AnimatedComponent({ children }: { children: React.ReactNode }) {
  const NewAnimatePresence: React.FC<NewAnimatePresenceProps> = AnimatePresence as never;

  return <NewAnimatePresence>{children}</NewAnimatePresence>;
}
